import React, { useState } from 'react';
import api from '../api'; // Adjust the import path as necessary

const InviteCode = ({ setAuth, logo }) => {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post('/auth', { code });
      localStorage.setItem('weddingToken', data.token);
      setAuth(true);
    } catch (err) {
      setError(err.response?.data?.message || 'Error authenticating');
    }
    setLoading(false);
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-br from-wedding-white via-wedding-light-white to-wedding-sage/5 p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img src={logo} alt="Wedding Logo" className="w-32 h-32 mx-auto mb-6 object-contain" />
          <h1 className="text-3xl font-serif text-wedding-dark-brown mb-2">Welcome</h1>
          <p className="text-wedding-dark-brown/70 text-sm leading-relaxed">
            Enter your invite code to access the wedding gallery
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label htmlFor="invite-code" className="block text-sm font-medium text-wedding-dark-brown mb-2">
              Invite Code
            </label>
            <input
              id="invite-code"
              type="tel"
              inputMode="numeric"
              pattern="[0-9]*"
              value={code}
              onChange={(e) => setCode(e.target.value.replace(/\D/g, ''))}
              placeholder="Enter your invite code"
              className="w-full p-4 border-2 border-wedding-sage/30 rounded-xl text-center text-lg font-mono tracking-wider focus:outline-none focus:border-wedding-sage focus:ring-2 focus:ring-wedding-sage/20 transition-all duration-200"
              maxLength={16}
              autoComplete="off"
              autoFocus
            />
          </div>

          <button
            type="submit"
            disabled={loading || code.length < 4}
            className="w-full p-4 bg-wedding-sage text-white rounded-xl font-semibold shadow-lg hover:bg-wedding-sage/90 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-wedding-sage focus:ring-offset-2"
          >
            {loading ? (
              <div className="flex items-center justify-center space-x-2">
                <svg className="animate-spin h-5 w-5" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"></path>
                </svg>
                <span>Verifying...</span>
              </div>
            ) : (
              'Access Gallery'
            )}
          </button>

          {error && (
            <div className="p-4 bg-red-50 border border-red-200 rounded-xl">
              <div className="flex items-center space-x-2">
                <svg className="w-5 h-5 text-red-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4m0 4h.01M21 12c0 4.97-4.03 9-9 9s-9-4.03-9-9 4.03-9 9-9 9 4.03 9 9z" />
                </svg>
                <p className="text-red-700 text-sm">{error}</p>
              </div>
            </div>
          )}
        </form>

        <div className="mt-8 text-center">
          <p className="text-xs text-wedding-dark-brown/50">
            Having trouble? Check your invitation for the correct code
          </p>
        </div>
      </div>
    </div>
  );
};

export default InviteCode;